module.exports = __webpack_public_path__ + "europa-20-emerald_number.jpg?2230843398ff047da5efc4b17da0243a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-20-emerald_number.jpg
// module id = 293
// module chunks = 0